import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import {
  getListCauHinhGoiTraGop,
  updateDataSearch,
} from "../../../../../../../actions/CauHinhGoiTraGop";
import { pushNotification } from "utils/notifications";
import BanHangTraGopApi from "service/banHangTraGopApi";

export const ModalKhoa = (props) => {
  const dataSearch = useSelector((state) => state.dataSearchCauHinhGoiTraGop);
  const dispatch = useDispatch();
  const [isSubbmit, setIsSubmit] = useState(false);
  const initData = {
    Id: 0,
    IdSanPham: 0,
    GiaGoc: 0,
    GiaTraGop: 0,
    KyHan: 0,
    PhanTramTraTruoc: 0,
    TrangThai: true,
  };
  const [dataCauHinh, setDataCauHinh] = useState(initData);
  useEffect(() => {
    if (props.Id > 0) {
      setDataCauHinh({
        ...dataCauHinh,
        Id: props.Id,
        IdSanPham: props.item.IdSanPham,
        GiaGoc: props.item.GiaGoc,
        GiaTraGop: props.item.GiaTraGop,
        KyHan: props.item.KyHan,
        PhanTramTraTruoc: props.item.PhanTramTraTruoc,
        TrangThai: false,
      });
    }
  }, []);
  const onSubmit = () => {
    const value = { ...dataCauHinh };

    if (props.Id > 0) {
      setIsSubmit(true);
      const param2 = value;
      var params = param2;
      BanHangTraGopApi.addCauHinhGoiSanPham(params).then((response) => {
        if (response.status == 200) {
          pushNotification(
            "Bạn đã khoá gói sản phẩm thành công",
            "success",
            "TOP_RIGHT",
            2000
          );
          props.onHide();
          dispatch(getListCauHinhGoiTraGop(dataSearch));
          setIsSubmit(false);
        } else {
          setIsSubmit(false);
          pushNotification(response.data.Message, "error", "TOP_RIGHT", 1000);
        }
      });
    }
  };
  return (
    <Modal
      {...props}
      size="modal-dialog modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-lock"></i>
          </span>{" "}
          Khoá
        </h4>
        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-body">
              <div className="form-group row">
                <label className="col-md-12 label-control text-center">
                  Bạn có chắc chắn muốn khóa gói sản phẩm này không?
                </label>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <button
          type="button"
          className="btn btn-new-main btn-checknew"
          onClick={onSubmit}
          disabled={isSubbmit}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-check"></i>
          </span>{" "}
          Xác nhận
        </button>

        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
